import api from '../services/api';
import ar from '@/local/ar';
import Vue from '@/main';
import { setLookupInLocalStorage } from '../helpers/utils';

export default {
  getMyBills(_context, payload) {
    return api.getMyBills(payload);
  },
  getDeceasedBills(_context, payload) {
    return api.getDeceasedBills(payload);
  },
  getBillTimeline(_context, objectKey) {
    return api.getBillTimeline(objectKey);
  },
  getBillDetails(_context, objectKey) {
    return api.getBillDetails(objectKey);
  },
  getBillItemDetails(_context, objectKey) {
    return api.getBillItemDetails(objectKey);
  },
  getBillAttributes(_context, objectKey) {
    return api.getBillAttributes(objectKey);
  },
  getMyBillsStatistics(_context) {
    return api.getMyBillsStatistics();
  },
  submitObjectionRequest(_context, payload) {
    return api.submitObjectionRequest(payload);
  },
  getObjectionRequest(_context, objectKey) {
    return api.getObjectionRequest(objectKey);
  },
  getBillStatuses(store) {
    return getData(store, 'billStatuses', 'getBillStatuses', 'حالات السندات');
  },
  getProviders(store) {
    return getData(store, 'providers', 'getProviders', 'المُسندين');
  },
  getObjectionReasons(_context, providerId) {
    return api.getObjectionReasons(providerId);
  },
  getBillInvoiceReport(_context, objectKey) {
    return api.getBillInvoiceReport(objectKey);
  },
  getBillUpdateDetails(_context, objectKey) {
    return api.getBillUpdateDetails(objectKey);
  },
};
const getData = ({ commit, state }, key, apiService, error, mapper = data => data) => {
  if (!state[key].length) {
    commit('update', {
      key,
      data: [],
    });
    return api[apiService]()
      .then((res) => {
        const data = mapper(res.data);
        commit('update', {
          key,
          data,
        });
        setLookupInLocalStorage(key, data);
        return data;
      })
      .catch(() => {
        Vue.toaster.error(ar.errors.wentWrongWhile(error));
        return [];
      });
  } else {
    return Promise.resolve(state[key]);
  }
};
